import { Stack } from "@mui/material";
import { RadioButtonGroup } from "components";
import { useState } from "react";
import { DownloadBtn } from "./DownloadBtn";

export const DownloadDrawerRadioBtns = ({
  radioMenuData,
  closeDownloadDrawer,
}: {
  radioMenuData: {
    label: string;
    value: string;
  }[];
  closeDownloadDrawer: () => void;
}) => {
  const [selectedDownloadOption, setSelectedDownloadOption] = useState(
    radioMenuData[0].value,
  );

  const radioMenu = radioMenuData.map((menuItem) => ({
    label: menuItem?.label,
    value: menuItem?.value,
  }));

  return (
    <>
      <Stack gap="24px">
        <RadioButtonGroup
          data={radioMenu}
          labelMappingKey="label"
          valueMappingKey="value"
          onChange={(value) => {
            setSelectedDownloadOption(value);
          }}
          value={selectedDownloadOption}
          radioButtonStyle={{
            p: "0px",
            mr: "8px",
            ":hover": {
              bgcolor: "transparent",
            },
          }}
          RadioGroupProps={{
            gap: "24px",
            "& .MuiFormControlLabel-root": {
              mx: "0",
            },
          }}
        />
      </Stack>
      <DownloadBtn
        variant={selectedDownloadOption}
        closeDownloadDrawer={closeDownloadDrawer}
      />
    </>
  );
};
